import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-bottom-sheet',
    templateUrl: './bottom-sheet.component.html',
    styleUrls: ['./bottom-sheet.component.scss']
})
export class BottomSheetComponent implements OnInit {

    @Input() height = '94vh';
    @Input() width = '100vw';
    @Input() loading = false;

    @Output() show = new EventEmitter<any>();
    @Output() hide = new EventEmitter<any>();

    isOpen = false;

    constructor() {
    }

    ngOnInit(): void {
    }

    open() {
        this.isOpen = true;
    }

    close() {
        this.isOpen = false;
    }

    toggle() {
        this.isOpen = !this.isOpen;
    }

    doShow() {
        this.show.emit();
    }

    doHide() {
        this.hide.emit();
    }
}
